import {
	Children,
	cloneElement,
	FC,
	isValidElement,
	ReactElement,
} from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Box from "../../layout/boxes/Box";

import { StepperProps, StepperSubComponents } from "./Stepper.types";
import StepperStep from "./StepperStep/StepperStep";

const INVALID_CHILD_ERROR_MESSAGE =
	"Invalid Stepper subcomponent: The child you provided is not a valid Stepper subcomponent, please provide Stepper.Step subcomponent";

const Stepper: FC<StepperProps> & StepperSubComponents = ({
	children,
	className,
	colorOn,
	...props
}) => {
	const block = new BemIt("Stepper");

	const steps = Children.map(children, (child, index) => {
		if (isValidElement(child)) {
			const isItem = child.type === StepperStep;

			if (!isItem) {
				console.error(INVALID_CHILD_ERROR_MESSAGE);
				return null;
			}

			return (
				isValidElement(child) &&
				cloneElement(child as ReactElement, {
					key: index,
					colorOn,
				})
			);
		}
	});

	return (
		<Box className={addClass(className).after(block)} display="flex" {...props}>
			{steps}
		</Box>
	);
};

Stepper.Step = StepperStep;

export default Stepper;
